import Lenis from "lenis";

let lenis = null;

export function initLenis() {
  if (lenis || typeof window === "undefined") return lenis;
  // allowNestedScroll lets panels with their own scrollbar (artwork story, dropdowns) scroll natively.
  lenis = new Lenis({ lerp: 0.09, smoothWheel: true, allowNestedScroll: true });
  const raf = (time) => {
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
  return lenis;
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export function scrollTop(immediate = false) {
  if (lenis) lenis.scrollTo(0, { immediate });
  else window.scrollTo(0, 0);
}
